import React, { useState } from 'react';
import StaticPage, { Section } from './StaticPage';

export default function ContactUs() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <StaticPage title="Contact Us" subtitle="We'd love to hear from you. Our team is here to help.">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Contact Info */}
        <Section title="Get In Touch">
          <div className="space-y-5">
            {[
              { icon: '✉️', label: 'Email', value: 'hello@rentalx.com.au', sub: 'Response within 24 hours' },
              { icon: '📞', label: 'Phone', value: '+61 1800 RENTAL', sub: 'Mon–Fri 9am–5pm AEST' },
              { icon: '📍', label: 'Address', value: '123 Student Street, Melbourne VIC 3000', sub: 'Walk-ins by appointment only' },
              { icon: '🕐', label: 'Business Hours', value: 'Mon–Fri: 9am–5pm AEST', sub: 'Closed on Australian public holidays' },
            ].map((c, i) => (
              <div key={i} className="flex gap-4 p-4 bg-sky-50 rounded-xl border border-sky-100">
                <span className="text-2xl">{c.icon}</span>
                <div>
                  <p className="text-xs font-semibold text-[#094f6f] uppercase tracking-wide">{c.label}</p>
                  <p className="font-medium text-gray-800">{c.value}</p>
                  <p className="text-xs text-gray-500">{c.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </Section>

        {/* Contact Form */}
        <Section title="Send a Message">
          {sent ? (
            <div className="p-6 bg-green-50 rounded-xl border border-green-200 text-center">
              <div className="text-4xl mb-3">✅</div>
              <p className="font-semibold text-green-800">Message sent!</p>
              <p className="text-sm text-green-600 mt-1">We'll get back to you within 24 hours.</p>
              <button onClick={() => setSent(false)} className="mt-4 text-sm text-[#094f6f] underline">Send another message</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                  <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} required
                    className="w-full px-3 py-2.5 border border-sky-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#094f6f]" placeholder="Your name" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                  <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required
                    className="w-full px-3 py-2.5 border border-sky-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#094f6f]" placeholder="your@email.com" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject *</label>
                <input value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} required
                  className="w-full px-3 py-2.5 border border-sky-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#094f6f]" placeholder="How can we help?" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
                <textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} required rows={5}
                  className="w-full px-3 py-2.5 border border-sky-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#094f6f]" placeholder="Tell us more..." />
              </div>
              <button type="submit" className="w-full bg-[#094f6f] text-white py-3 rounded-lg font-semibold hover:bg-[#094f6f]/90 transition-colors">
                Send Message
              </button>
            </form>
          )}
        </Section>
      </div>
    </StaticPage>
  );
}
